module.exports = __webpack_public_path__ + "images/day.png";


//////////////////
// WEBPACK FOOTER
// ./images/day.png
// module id = 1110
// module chunks = 1